@if (html) {
    <sew-tab-bar hierarchy="sub">
        <sew-tab-bar-item
            [name]="'PRODUCT.PARTS_DESCRIPTION.TITLE' | translate"
            selected="true"
        ></sew-tab-bar-item>
    </sew-tab-bar>
    <div [innerHTML]="html"></div>
} @else {
    <div class="recommendation-unavailable">
        <img src="assets/pictures/placeholder-no-product-image.svg" alt="" title="" />
        <div>
            <sew-headline level="5">{{
                'PRODUCT.PARTS_DESCRIPTION.UNAVAILABLE.TITLE' | translate
            }}</sew-headline>
            <p>{{ 'PRODUCT.PARTS_DESCRIPTION.UNAVAILABLE.TEXT' | translate }}.</p>
        </div>
    </div>
}
